import { render, staticRenderFns } from "./Step6.vue?vue&type=template&id=cd38da3a&"
import script from "./Step6.vue?vue&type=script&lang=ts&"
export * from "./Step6.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports